export const AD = {
  PURPLE: '#6344d4',
  PURPLE_STRONG: '#6d4ed5',
  PURPLE_SOFT: '#ede9fe',
  PURPLE_PALE: '#c4b5fd',
  NAVY: '#1e3a8a',
  INK: '#0f172a',
  INK_700: '#334155',
  INK_600: '#475569',
  SLATE: '#64748b',
  SLATE_LIGHT: '#94a3b8',
  HAIR: '#e2e8f0',
  HAIR_SOFT: '#f1f5f9',
  BG: '#f8fafc',
  BG_DEEP: '#f1f5f9',
  RED: '#dc2626',
  RED_BG: '#fef2f2',
  GREEN: '#16a34a',
  GREEN_BG: '#d1fae5',
  AMBER: '#f59e0b',
  AMBER_BG: '#fef3c7',
  CYAN: '#0891b2',
  CYAN_BG: '#cffafe',
};

export const AD_STATUS: Record<string, { label: string; bg: string; fg: string }> = {
  published:  { label: 'Published',  bg: AD.GREEN_BG,  fg: AD.GREEN },
  draft:      { label: 'Draft',      bg: AD.AMBER_BG,  fg: '#92400E' },
  deprecated: { label: 'Deprecated', bg: AD.HAIR,      fg: AD.SLATE },
};

export const AD_ICON_PATHS: Record<string, string> = {
  search:       'M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z',
  plus:         'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z',
  prompt:       'M4 4h16v3H4zm0 5h16v3H4zm0 5h11v3H4z',
  tool:         'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z',
  history:      'M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8z',
  play:         'M8 5v14l11-7z',
  copy:         'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z',
  link:         'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7a5 5 0 100 10h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4a5 5 0 000-10z',
  check:        'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z',
  download:     'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z',
  bolt:         'M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z',
  chevron:      'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z',
  close:        'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
  warning:      'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z',
  more:         'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
  filter:       'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z',
  sparkle:      'M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z',
  refresh:      'M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z',
  arrow_right:  'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z',
  check_circle: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z',
  user:         'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
  trash:        'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z',
};
